<template>
  <div class="absolute left-500px top-190px pt-20px pl-10px bg-[#1c404aeb] z-999" v-drag>
    <div
      class="w-30px h-30px absolute right-0px top-5px iconfont icon-line-left text-[#fff] text-center leading-30px z-999"
      @click="hide"
    ></div>
    <!-- <v-chart
      @click="clickChart"
      :options="options"
      autoresize
      class="w-full h-full"
      id="chart1"
      ref="charts"
    ></v-chart> -->
    <div class="w-full h-470px" id="chart1" ref="charts"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import EventBus from './EventBus'

export default {
  components: {},
  props: {
    CrossSectionChart: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      lastIndex: -1, // 最后一个高亮点
      lastResData: [], // 最终整理的需渲染的数据
      options: {
        tooltip: {
          trigger: 'item',
          formatter: function name(params) {
            const serialNumber = params.data.serialNumber
            const code = params.data.code
            return `位号: ${code}<br> 序号: ${serialNumber}`
          },
          position: (point) => {
            return [point[0] + 10, point[1] - 50]
          },
        },
        xAxis: {
          splitLine: {
            show: false,
          },
          min: 0,
          type: 'value',
          axisLabel: {
            show: false,
            color: '#fff',
            fontSize: 12,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#fff',
            },
          },
          data: [],
        },
        dataZoom: [
          {
            type: 'inside',
            show: true,
            start: 0,
            end: 100,
            zoomOnMouseWheel: true,
          },
        ],
        grid: {
          containLabel: true,
          left: 20,
          right: 10,
          top: 10,
          bottom: 20,
        },
        yAxis: {
          max: null,
          name: '',
          boundaryGap: ['20%', '20%'],
          nameTextStyle: {
            fontSize: 12,
            color: '#fff',
            padding: [0, 0, 0, -30],
          },
          min: 0,
          axisLabel: {
            show: false,
            color: '#fff',
            fontSize: 12,
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#fff',
            },
          },
        },
        series: [
          {
            type: 'scatter',
            data: [],
            markLine: {},
            itemStyle: {
              normal: {
                color: '#eee',
              },
            },
            label: {
              show: true,
              position: 'inside',
              formatter(param) {
                return param.data.label.value
              },
            },
          },
        ],
      },
    }
  },
  watch: {},
  computed: {},
  created() {
    EventBus.$on('createCrossSection', this.createCrossSection)
    EventBus.$on('crossChartMarkHighLight', this.crossChartMarkHighLight)
    EventBus.$on('crossChartExport', this.crossChartExport)
  },
  beforeDestroy() {
    EventBus.$off('createCrossSection', this.createCrossSection)
    EventBus.$off('crossChartMarkHighLight', this.crossChartMarkHighLight)
    EventBus.$off('crossChartExport', this.crossChartExport)
    this.chart.dispose()
  },
  mounted() {
    this.$nextTick(() => {
      try {
        this.chart = echarts.init(document.getElementById('chart1'))
        console.log('-->this.chart', this.chart)
        this.chart.setOption(this.options)
        this.chart.on('dataZoom', (params) => {
          // 监听缩放操作，同步对散点半径和点内文字缩放
          const zoomScale = (params.batch[0].end - params.batch[0].start) / 100
          this.chart.setOption({
            series: [
              {
                data: _.map(this.lastResData, (i) => {
                  return {
                    value: [Number(i.center2d[0].toFixed(2)), Number(i.center2d[1].toFixed(2))],
                    itemStyle: {
                      color: `#${i.color.toString(16)}`,
                    },
                    symbolSize: (i.radians * 100) / zoomScale,
                    node: i.node,
                    code: i.code,
                    radians: i.radians,
                    serialNumber: i.serialNumber,
                    index: i.index,
                    recordIndex: i.recordIndex,
                    emphasis: {
                      itemStyle: {
                        color: `#${i.color.toString(16)}`,
                        shadowBlur: 10,
                        shadowColor: 'rgba(0, 213, 215, 1)',
                      },
                    },
                    label: {
                      value: i.serialNumber,
                      fontSize: (i.radians * 40) / zoomScale,
                    },
                  }
                }),
              },
            ],
          })
        })
        this.chart.on('click', this.clickChart)
      } catch (error) {
        console.error('chartDom listen error', error)
      }
    })
  },
  methods: {
    /**
     * @description 绘制截面图
     * @param {Number} chartMaxHeight 图标最大值
     * @param {Array} markLineData 分层线数据
     * @param {Array} markCollectionWithName 分层标记数据
     * @param {Array} res 整理后的图表数据
     */
    createCrossSection({ chartMaxHeight, markLineData, markCollectionWithName, res }) {
      this.lastResData = res
      this.chart.clear()
      this.options = this.$options.data().options
      // 设置y轴最大值，充分利用空间
      this.options.yAxis.max = chartMaxHeight
      // 绘制分层线
      this.options.series[0].markLine = {
        symbol: ['none', 'none'],
        label: {
          show: false,
        },
        silent: true,
        data: markLineData,
        lineStyle: {
          color: '#fff',
          width: 1,
        },
      }
      // 给指定位置标记层级
      this.options.graphic = markCollectionWithName
      // 设置x轴
      this.options.xAxis.data = _.map(res, (i) => {
        return Number(i.center2d[0].toFixed(2))
      })
      // 接入数据和基本参数
      this.options.series[0].data = _.map(res, (i) => {
        return {
          value: [Number(i.center2d[0].toFixed(2)), Number(i.center2d[1].toFixed(2))],
          itemStyle: {
            color: `#${i.color.toString(16)}`,
          },
          symbolSize: i.radians * 100,
          node: i.node,
          code: i.code,
          radians: i.radians,
          serialNumber: i.serialNumber,
          index: i.index,
          recordIndex: i.recordIndex,
          emphasis: {
            itemStyle: {
              color: `#${i.color.toString(16)}`,
              shadowBlur: 10,
              shadowColor: 'rgba(0, 213, 215, 1)',
            },
          },
          label: {
            value: i.serialNumber,
            fontSize: i.radians * 40,
          },
        }
      })
      this.chart.setOption(this.options)
    },
    /**
     * @description 图标高亮及恢复状态
     * @param {Number} index 需要高亮处理的数据序号
     * @param {Number} lastIndex 需要恢复状态的数据序号
     */
    crossChartMarkHighLight({ index, lastIndex }) {
      console.log('表单点选参数', index, lastIndex)
      if (lastIndex !== -1) {
        this.chart.dispatchAction({
          type: 'downplay',
          seriesIndex: 0,
          dataIndex: lastIndex,
        })
      }
      if (index !== -1) {
        this.chart.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex: index,
        })
      }
      this.lastIndex = index
    },
    // 导出
    crossChartExport({ workBook, workSheet }) {
      const imgData = this.chart.getDataURL({
        pixelRatio: 2,
        backgroundColor: '#265585',
      })
      const baseData = imgData.split('base64,')
      const signImage = workBook.addImage({
        base64: baseData[1],
        extension: 'png',
      })
      workSheet.addImage(signImage, {
        tl: { col: 0, row: 0 },
        ext: { width: 813, height: 490 },
      })
      workBook.xlsx.writeBuffer().then((excelBuffer) => {
        const excelBlob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        const downloadLink = document.createElement('a')
        downloadLink.href = URL.createObjectURL(excelBlob)
        downloadLink.download = '断面分析.xlsx'
        downloadLink.click()
      })
    },
    /**
     * @description 点击图标节点
     */
    async clickChart(param) {
      const dataIndex = _.findIndex(this.lastResData, ['node', param.data.node])
      await this.crossChartMarkHighLight({ index: dataIndex, lastIndex: this.lastIndex })
      EventBus.$emit('crossMarkClick', { param, lastIndex: this.lastIndex })
    },
    // 隐藏弹窗
    hide() {
      this.$emit('closeGxDetail', 'CrossSectionChart')
    },
  },
}
</script>
<style lang="scss" scoped>
.detail-dialog {
  ::v-deep .el-loading-mask {
    background: #1a4447ad !important;
  }
}
</style>
